/** @jsx jsx **/
import { jsx, Box } from 'theme-ui'
import { FC } from 'react'
import { space } from '~/gatsby-plugin-theme-ui'

type Props = {
  label?: string
  color?: string
}

const ProductLabelGroup: FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: space.md3,
        top: space.gridGap3,
        '>*': {
          ml: space.sm1,
        },
      }}
    >
      {children}
    </Box>
  )
}

export default ProductLabelGroup
